import { Injectable } from '@angular/core';
import { SecureStorageService } from './secure-storage.service';

@Injectable({
  providedIn: 'root'
})
export class PackageService {

 private package: any = null;

  constructor(private secureStorage: SecureStorageService) {}

  async load(): Promise<void> {
    try {
      const raw = await this.secureStorage.getItem('package');
      this.package = JSON.parse(raw || '{}');
    } catch (error) {
      console.error('Failed to load permissions:', error);
      this.package = {};
    }
  }

  getPermission(key: string): string {
    return this.package?.[key] || 'no-access';
  }

  getAll(): any {
    return this.package || {};
  }
}
